import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

export default function HoldPosition({ status, position, totalCopies, holdText }) {
  const renderPosition = () => (
    <FormattedMessage
      id="holds_queue_info"
      values={{ holdsPosition: <strong>{position}</strong>, totalCopies }} />
  );

  return (
    <span className="cp-hold-position" data-test-id="holds_queue_info">
      {position >= 1 ? renderPosition() : status === 'NOT_YET_AVAILABLE' && holdText}
    </span>
  );
}

HoldPosition.propTypes = {
  status: PropTypes.string,
  holdText: PropTypes.string,
  position: PropTypes.number,
  totalCopies: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/HoldPosition/HoldPosition.jsx